module.exports = __webpack_public_path__ + "img/border-middle.b59ac707.svg";